import ReactivationErrorScreen from 'features/reactivation/screens/Error/ReactivationError';
import React from 'react';

export default function ReactivationErrorPage() {
  return <ReactivationErrorScreen />;
}
